import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('./views/404.vue'),
    meta: {
      title: '404'
    }
  },
  {
    name: 'index',
    component: () => import('./views/index'),
    meta: {
      title: '主页'
    }
  },
  {
    name: 's',
    component: () => import('./views/s'),
    meta: {
      title: '特别'
    }
  },
  {
    name: 'con',
    component: () => import('./views/confirmation'),
    meta: {
      title: 'con'
    }
  },
  {
    name: 'result',
    component: () => import('./views/result'),
    meta: {
      title: 'result'
    }
  },

  {
    name: 'last',
    component: () => import('./views/last'),
    meta: {
      title: 'last'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ 
  mode: 'history', // 默认 hash
  routes:routes 
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
